import React from 'react';
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import { Admin } from "layouts/Admin";
import { Auth } from "layouts/Auth";
import { Error } from "layouts/Error";
import "assets/plugins/nucleo/css/nucleo.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "assets/scss/argon-dashboard-react.scss";
import "styles/_main.scss";
import 'react-dual-listbox/lib/react-dual-listbox.css';
const App = () => {
    return (
        <BrowserRouter>
            <Switch>
                <Route path="/admin" render={props => <Admin {...props} />} />
                <Route path="/auth" render={props => <Auth {...props} />} />
                <Route path="/errors" render={props => <Error {...props} />} />
                <Redirect from="/" to="/admin/index" />
            </Switch>
        </BrowserRouter>
    );
}

export default App;